import { render, staticRenderFns } from "./OpenTokSubscriber.vue?vue&type=template&id=4fa84f34&"
import script from "./OpenTokSubscriber.vue?vue&type=script&lang=js&"
export * from "./OpenTokSubscriber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports